import React, {  } from 'react';
import styled from 'styled-components/macro';

import MarketingInput from './MarketingInput';
import { InputValidation } from '../../../components/Forms';

interface InputWithChildren {

    children?: React.ReactNode;
    name: string;
    label: any;
    placeholder: string;
    value: string;
    onBlur: (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onChange: (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    disabled?: boolean;
    type?: string;
    validation?: InputValidation;
    rightAligned?: boolean;
    prefix?: string;
    autoComplete?: string;
    maxlength?: number;
    className?: string;
    autoFocus?: boolean;
    labelOpacity?: number;
    isTextArea?: boolean;
}

const InputWithPostfixedText = (
    {
        children,
        ...props
    }: InputWithChildren
) => (<Wrapper>
    <MarketingInput
        name={props.name}
        label={props.label}
        placeholder={props.placeholder}
        value={props.value}
        onBlur={props.onBlur}
        onKeyDown={props.onKeyDown}
        onChange={props.onChange}
        disabled={props.disabled}
        type={props.type}
        validation={props.validation}
        rightAligned={props.rightAligned}
        prefix={props.prefix}
        autoComplete={props.autoComplete}
        maxlength={props.maxlength}
        className={props.className}
        autoFocus={props.autoFocus}
        labelOpacity={props.labelOpacity}
        isTextArea={props.isTextArea}
    />
    <ChildrenWrapper>{children}</ChildrenWrapper>
</Wrapper>);

const Wrapper = styled.div`
    position: relative;
`;

const ChildrenWrapper = styled.div`
    position: absolute;
    top: 43px;
    left: 82%;
    z-index: 1;

    @media (max-width: 768px) {
        left: 75%;
    }
`;

export default InputWithPostfixedText;
